import { createContext } from 'react';

/** The flow's own navigation, or guided planning's for a consumer handed over from it (see `guided-journey`). */
export type ConsumerChrome = 'consumer' | 'guided';

export const ConsumerChromeContext = createContext<ConsumerChrome>('consumer');
